import _plugin_vue_export_helper_default from "../../../../_virtual/_plugin-vue_export-helper.js";
import RequestBody_vue_vue_type_script_setup_true_lang_default from "./RequestBody.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                                */
//#region src/v2/blocks/request-block/components/RequestBody.vue
var RequestBody_default = /*#__PURE__*/ _plugin_vue_export_helper_default(RequestBody_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-ec7e5b86"]]);
//#endregion
export { RequestBody_default as default };

//# sourceMappingURL=RequestBody.vue.js.map